import React, { Component } from 'react';

class Home extends Component {
  render() {
    return (
	<div class="w3-container w3-padding-large">
		<h2><a class="w3-button w3-tag w3-padding w3-green" href="https://github.com/make91">GitHub link</a></h2>
	</div>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/Home.js